import React, { useState } from 'react'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import './resetPassword.css'
import queryString from 'query-string'
import Form from '../../components/form/Form'
import { Spinner } from 'react-bootstrap'
import axios from 'axios'
import { ENDPOINT } from '../../helpers/Helper'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const renderResetPasswordForm = (item, index) => (
    <React.Fragment key={index}>
        <p style={{ marginTop: "1rem", color: "rgb(95, 95, 95)" }}>{item.placeholder}</p>
        <div className='input-black'>
            <input
                required
                type={item.type}
                placeholder={item.placeholder}
                value={item.value}
                onChange={item.onChange}
            />
        </div>
    </React.Fragment>
)

const renderLoading = () => (
    <Spinner animation="border" variant="light"/>
)

function ResetPassword() {
    const navigate = useNavigate();

    const { token } = queryString.parse(window.location.search);

    const [loading, setLoading] = useState();
    const [newPassword, setNewPassword] = useState();
    const [confirmNewPassword, setConfirmNewPassword] = useState();

    const resetInputData = [
        {
            type: 'password',
            placeholder: 'New Password',
            value: newPassword,
            onChange: (e) => setNewPassword(e.target.value)
        },
        {
            type: 'password',
            placeholder: 'Confirm New Password',
            value: confirmNewPassword,
            onChange: (e) => setConfirmNewPassword(e.target.value)
        }
    ]

    const submitResetPassword = e => {
        e.preventDefault();
        setLoading(true);

        if (newPassword === confirmNewPassword) {
            axios.post(`${ENDPOINT}/auth/reset-password`, {
                "resettoken": token,
                "password": newPassword
            })
                .then(res => {
                    toast("Password Reset Successfully. Please try signing in again", {
                        type: "success",
                        position: "top-right",
                        autoClose: "5000",
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                    });
                    setLoading(false);
                    navigate('/');
                })
                .catch(err => {
                    toast(`Oops! ${err.response.data.error}`, {
                        type: "error",
                        position: "top-right",
                        autoClose: "5000",
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                    });
                    setLoading(false);
                })
        } else {
            toast(`Oops! Something wrong happened. Kindly use the resent link sent to your email.`, {
                type: "error",
                position: "top-right",
                autoClose: "5000",
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
            setNewPassword('');
            setConfirmNewPassword('');
            setLoading(false);
            navigate("/");
        }
    }

    return (
        <div className='resetPassword'>
            <Navigation background="theme-color" logo='https://res.cloudinary.com/emacon-production/image/upload/v1638427484/the-outlet/Artboard_7_copy_7png_j6chrh.png' />

            <div className='main_section'>
                <div>
                    <h3 style={{ fontWeight: "bold", textAlign: "center" }}>Reset Password</h3>
                   <Form
                        flexForm={false}
                        formInputData={resetInputData}
                        renderForm={(item, index) => renderResetPasswordForm(item, index)}
                        buttonContent={loading ? renderLoading(): "Change Password"}
                        buttonColor="main-bg"
                        buttonContentColor="white"
                        borderRadius="all"
                        handleForm={submitResetPassword}
                    /> 
                </div>

                
            </div>

            <Footer/>
        </div>
    )
}

export default ResetPassword
